import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=7d27dc3e&scoped=true&"
var script = {}
import style0 from "./Photos.vue?vue&type=style&index=0&id=7d27dc3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d27dc3e",
  null
  
)

export default component.exports